import type { Page } from '@shared/types/Tilelist';
import type { IntentResult } from '@shared/types/types.ts';
import { isInterleavedIntent, isRankedIntent } from '@shared/types/types.ts';
import type { BracketLayout } from '@tilelist/domain/composition/BracketLayout.ts';

/**
 *
 *
 *
 */
export function getRankedPaging(
    intents: IntentResult[],
    layout: BracketLayout,
    comparisonId: string | undefined,
): Page {
    const primaryIntent = intents.find(isInterleavedIntent) ?? intents.find(isRankedIntent);
    const primaryMeta = primaryIntent?.meta;

    return {
        sortiertnach: primaryMeta?.sortOrder ?? '',
        o: primaryMeta?.offset?.toString() ?? '',
        l: layout.layoutParam,
        c: comparisonId ?? '',
    };
}
